import {
  HttpClient
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataSessionService } from '../../../core/services/data-session.service';
import { ContentPWBIResponse, ContentResponse, DownloadPWBIResponse } from '../type/content';

@Injectable({ providedIn: 'root' })
export class ContentService {
  private readonly _http = inject(HttpClient);
  private readonly _dataSessionService = inject(DataSessionService);

  getContentsHome = (): Observable<ContentResponse> =>
    this._http.get<ContentResponse>(`${this._dataSessionService.baseUrl}/users/contents`);

  getContentPowerBi = (content: string): Observable<ContentPWBIResponse> =>
    this._http.get<ContentPWBIResponse>(`${this._dataSessionService.baseUrl}/users/access-powerbi?content=${content}`);

  downloadPowerBi = (content: string, exportId?: string, bookmarkState?: string): Observable<DownloadPWBIResponse> => {
      const httpParams: { [key: string]: string } = {};

    if (content) {
      httpParams['content'] = content;
    }
    if (exportId) {
      httpParams['exportId'] = exportId;
    }
    return this._http.post<DownloadPWBIResponse>(
      `${this._dataSessionService.baseUrl}/users/report`,
      { bookmarkState: bookmarkState },
      { params: httpParams }
    );
  }

  downloadFile(base64Data: string, contentType: string, contentDisposition: string): void {
    try {
      // Extraer el nombre del archivo del contentDisposition
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      const filename = filenameMatch ? filenameMatch[1] : 'download.pdf';

      // Convertir base64 a blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });

      // Crear URL y descargar
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      console.log('Descarga iniciada:', filename);
    } catch (error) {
      console.error('Error al procesar el archivo:', error);
    }
  }
}
